import { Injectable } from "@angular/core";
import { Observable, ReplaySubject, Subject } from "rxjs";
import { IUserSession } from "src/app/shared/models/IUserSession";

@Injectable({
    providedIn: 'root'
  })
  export class UserSessionService {
  
    private _userSession: Subject<IUserSession> = new ReplaySubject<IUserSession>(null);
  
    constructor() { }
  
    setUserSession(userSession: IUserSession) {
      this._userSession.next(userSession);
    }
  
    getUserSession(): Observable<IUserSession> {
      return this._userSession;
    }
  
    clearUserSession() {
      this._userSession.next(null);
    }
  
  }